(function () {
  function initialize() {
    var form = document.getElementById('LiittAutomaticCountryForm');
    if (!form || (window.Shopify && window.Shopify.designMode) || form.dataset.liittCountryInitialized === 'true') return;
    form.dataset.liittCountryInitialized = 'true';
    document.addEventListener('submit', function (event) {
      if (event.defaultPrevented || !event.submitter || event.submitter.name !== 'checkout') return;
      var action = new URL(event.target.action, window.location.href);
      if (action.origin !== window.location.origin || !/\/cart\/?$/.test(action.pathname)) return;
      event.preventDefault();
      window.location.assign((form.dataset.routesRoot || '/') + 'checkout?checkout%5Bshipping_address%5D%5Bcountry%5D=' +
        encodeURIComponent(form.dataset.currentCountry));
    });
    var manualCountryKey = 'liitt-country-manual-v1';
    var manualLanguageKey = 'liitt-language-manual-v1';
    var redirectKey = 'liitt-country-redirect-v1';
    var stopped = false;
    var submitted = false;
    var controller = new AbortController();
    var timeout;
    function stop() {
      stopped = true;
      controller.abort();
      window.clearTimeout(timeout);
    }
    function remember(key, value) {
      stop();
      try { localStorage.setItem(key, value); } catch (error) {}
    }
    function languageInput(container) {
      return container.querySelector('input[name="language_code"], input[name="locale_code"], select[name="language_code"], select[name="locale_code"]');
    }
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('localization-form a[data-value]');
      var manualForm = link && link.closest('localization-form');
      if (!manualForm) return;
      var country = manualForm.querySelector('input[name="country_code"], select[name="country_code"]');
      var language = languageInput(manualForm);
      if (language && (!country || link.hasAttribute('hreflang') || link.hasAttribute('lang'))) {
        remember(manualLanguageKey, link.dataset.value);
      } else if (country) {
        remember(manualCountryKey, link.dataset.value);
      }
    }, true);
    document.addEventListener('submit', function (event) {
      if (event.target === form) return;
      var country = event.target.querySelector('input[name="country_code"], select[name="country_code"]');
      var language = languageInput(event.target);
      if (country) remember(manualCountryKey, country.value);
      if (language) remember(manualLanguageKey, language.value);
      if (event.submitter && event.submitter.name === 'checkout') stop();
    }, true);
    document.addEventListener('change', function (event) {
      if (!event.target.closest || !event.target.closest('localization-form')) return;
      if (event.target.name === 'country_code') remember(manualCountryKey, event.target.value);
      if (event.target.name === 'language_code' || event.target.name === 'locale_code') remember(manualLanguageKey, event.target.value);
    }, true);
    window.addEventListener('liitt:purchase-start', stop);
    document.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-liitt-direct-checkout], #CartDrawer-Checkout, [name="checkout"], .shopify-payment-button')) stop();
    }, true);
    var parameters = new URLSearchParams(window.location.search);
    if (parameters.has('country') || parameters.has('currency') || parameters.has('preview_theme_id')) return;
    var currentCountry = form.dataset.currentCountry;
    var currentLocale = (form.dataset.currentLocale || '').toLowerCase();
    var availableLocales = (form.dataset.availableLocales || '').toLowerCase().split(',').filter(Boolean);
    var manualCountry = false;
    var manualLanguage = false;
    try {
      manualCountry = Boolean(localStorage.getItem(manualCountryKey));
      manualLanguage = Boolean(localStorage.getItem(manualLanguageKey));
    } catch (error) {}
    var root = form.dataset.routesRoot || '/';
    var firstSegment = window.location.pathname.split('/')[1].toLowerCase();
    var explicitLocale = availableLocales.some(function (locale) {
      return firstSegment === locale || firstSegment.indexOf(locale + '-') === 0;
    });
    function preferredLocale(country) {
      if (manualLanguage || explicitLocale || !currentLocale || !availableLocales.length) return currentLocale;
      var target;
      var preferences = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
      if (country === 'NO' || country === 'AE') {
        target = country === 'NO' ? 'nb' : 'ar';
        for (var index = 0; index < preferences.length; index += 1) {
          var browserLocale = String(preferences[index]).toLowerCase().split('-')[0];
          if (browserLocale === 'en') { target = 'en'; break; }
          if (country === 'NO' && /^(nb|no|nn)$/.test(browserLocale)) { target = 'nb'; break; }
          if (country === 'AE' && browserLocale === 'ar') { target = 'ar'; break; }
        }
      } else if (country === 'ZA' || country === 'NZ' || country === 'IE') {
        target = 'en';
      }
      return target && availableLocales.indexOf(target) !== -1 ? target : currentLocale;
    }
    function returnPath(localeChanged) {
      var path = window.location.pathname;
      if (localeChanged) {
        var rootPath = new URL(root, window.location.href).pathname;
        var prefix = rootPath.replace(/\/$/, '');
        if (prefix && (path === prefix || path.indexOf(prefix + '/') === 0)) path = path.slice(prefix.length) || '/';
        else if (firstSegment === currentLocale || firstSegment.indexOf(currentLocale + '-') === 0) {
          path = path.slice(firstSegment.length + 1) || '/';
        }
      }
      return path + window.location.search + window.location.hash;
    }
    function applyLocalization(code) {
      if (stopped || submitted) return;
      var locale = preferredLocale(code);
      var localeChanged = Boolean(locale && locale !== currentLocale);
      if (code === currentCountry && !localeChanged) {
        try { sessionStorage.removeItem(redirectKey); } catch (error) {}
        return;
      }
      try {
        var previous = JSON.parse(sessionStorage.getItem(redirectKey) || 'null');
        if (previous && previous.from === currentCountry && previous.to === code && previous.fromLocale === currentLocale && previous.toLocale === locale && Date.now() - previous.time < 10000) return;
        sessionStorage.setItem(redirectKey, JSON.stringify({from:currentCountry,to:code,fromLocale:currentLocale,toLocale:locale,time:Date.now()}));
      } catch (error) { return; }
      form.querySelector('input[name="country_code"]').value = code;
      var localeField = languageInput(form);
      if (localeField && locale) localeField.value = locale;
      form.querySelector('input[name="return_to"]').value = returnPath(localeChanged);
      submitted = true;
      form.submit();
    }
    if (manualCountry) { applyLocalization(currentCountry); return; }
    timeout = window.setTimeout(stop, 2500);
    fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(currentCountry) + '&language[enabled]=false', {
      credentials: 'same-origin', signal: controller.signal
    }).then(function (response) {
      if (!response.ok) throw new Error('Country detection unavailable');
      return response.json();
    }).then(function (result) {
      if (stopped) return;
      var country = result.detected_values && result.detected_values.country;
      var code = country && country.handle;
      if (!code) { applyLocalization(currentCountry); return; }
      var supported = code === currentCountry || (result.suggestions || []).some(function (suggestion) {
        return suggestion.parts && suggestion.parts.country && suggestion.parts.country.handle === code;
      });
      if (supported) applyLocalization(code);
    }).catch(function () {}).finally(function () { window.clearTimeout(timeout); });
  }
  initialize();
})();
